<!--
 * @Author: Merlin
 * @Date: 2024-07-19 09:59:34
 * @LastEditors: Merlin
 * @LastEditTime: 2025-03-18 11:27:30
 * @Description: 
当前组件名称 <ModalWinJackpotHandler  用于游戏：crash, dice, hilo, spaceDice, 
内含的子组件名： <ModalWinJackpot  有用于游戏 circle, plinko 
其实对 <ModalWinJackpot 的调用应改为此组件，即：<ModalWinJackpotHandler 
-->

<template>
    <ModalWinJackpot 
        v-model="winJackpotVisible"
        :data='winJackpotData'
    />
</template>

<script setup lang="ts">
import { useJackPotSocket } from '@/socket/jackpot';
import { useUserStore } from '~/stores/user';

const { ON_WINJACKPOT } = useJackPotSocket();

// ↓ 游戏名全部是纯小写
export type GameName = (
    'dice' | 'spacedice'
    | 'hilo' | 'crash'
    | 'circle' | 'plinko'
);

const props = defineProps({
    gameName: {
        type: String as PropType<GameName>,
        required: true,
    },
});

const hasWon = ref(false);
const winJackpotVisible = ref(false);
const winJackpotData = ref({});
let toStopListening = () => {};


const toListenJackpotWin = ()=>{
    console.log("开始监听中奖通知：", props.gameName); 
    // ↓ 监听中奖通知 
    toStopListening = ON_WINJACKPOT(props.gameName, (res) => {
        const isMine = res.jackpot.user._id === useUserStore().id;
        console.log("已经中奖，是否是当前用户中奖？", isMine); 
        if (!isMine) return; // 和我无关
        winJackpotData.value = {
            game: res.jackpot.game,
            ...res.jackpot, // ← 这里本身有一个 game 属性
        };
        hasWon.value = true;
    });
}


const showJackpotWin = () => {
    const bHasWonJackpot = !!hasWon.value;
    if (bHasWonJackpot){
        winJackpotVisible.value = true;
        hasWon.value = false; // 复位
    }
    // ↓ 调用方收到此值后，以利于自动模式暂停
    return bHasWonJackpot;
};

const hideJackpotWin = () => {
    winJackpotVisible.value = false;
};

defineExpose({
    showJackpotWin,
    hideJackpotWin,
});

onMounted(()=>{
    toListenJackpotWin();
});
onBeforeUnmount(()=>{
    toStopListening();
});

</script>
